import { Blog } from '@/resource/blog/blog.model';

const generateBLogUrl = (blog: Blog) => {
  const name = blog.title
    .toLowerCase()
    .trim()
    .replaceAll(' ', '-');

  return (name + `-${blog.uuid}`).replace(
    /[&\\/\\#,+()$~%.'":*?^<>=+{}!@]/g,
    '',
  );
};

export default generateBLogUrl;
